import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';

const renderApp = async () => {
    const { default: App } = await import('App.jsx');
    const rootElement = document.getElementById('root');
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
};

const startApplication = () => {
    renderApp().catch(console.error);
};

const configReady = window.__APP_CONFIG_READY__;

if (configReady?.then) {
    configReady.then(startApplication).catch(() => startApplication());
} else {
    startApplication();
}
